<template>
    <div class="row">
        <template v-for="(item,key) in formItems" :key="key+item.model_key">
            <template v-if="item.type == 'Section'">
                <RecursiveSection :key="key+item.type+`${Math.random().toString(16)}`"
                                  @updateParentItems="updateParentItems"
                                  :enabled="enabled"
                                  v-bind="{item:item,items:formItems,iterator:key}"/>
            </template>

            <template v-else>
                <WidgetInputs :key="key+item.type+`${Math.random().toString(16)}`"
                              @updateParentItems="updateParentItems"
                              :enabled="enabled"
                              v-bind="{item:item,items:formItems,iterator:key}"
                />
            </template>
        </template>
    </div>
</template>

<script lang="ts">
  import {
    defineComponent,
    reactive,
    toRefs,
    inject,
    computed,
    onMounted,
    defineAsyncComponent,
    nextTick,
  } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import 'flatpickr/dist/flatpickr.css';
  import * as _ from 'lodash';
  import { useStore } from 'vuex';

  export default defineComponent({
    name: 'FormBuilder',
    components: {
      Field,
      ErrorMessage,
      WidgetInputs: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./WidgetInputs.vue'),
      ),
      RecursiveSection: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./RecursiveSection.vue'),
      ),
    },
    props: {
      items: Object,
      enabled: Boolean,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();
      const store = useStore();

      const state = reactive({
        formItems: props.items,
        enabled: props.enabled,
      });

      let FormJSON = computed(() => {
        return store.getters['modulePrograms/getFormJSON'];
      });

      const updateParentItems = (items) => {
        state.formItems = items;
        context.emit('updateParentItems', items);
      };

      return {
        updateParentItems,
        ...toRefs(state),
        i18n,
        FormJSON,
        helpers,
      };
    },
  });
</script>